import $ from 'jquery';
import { breakpoints } from './_site';

let timeout = {};

export const scroll = () => {
    var $window = $(window),
        // breakpoints = site.breakpoints,
        activeClass = 'return-top-active';

    if ($window.scrollTop() >= $('#header').outerHeight()) {
        $('body').addClass(activeClass);
    } else {
        $('body').removeClass(activeClass);
    }
};
export const resize = () => {
    var $window = $(window);

    // md
    if ($window.width() < breakpoints.md) {
        responsivePageInfo(true);
    } else {
        responsivePageInfo(false);

        // body status
        // hideBackdrop();
    }
};
export const responsivePageInfo = (flag) => {
    var $el = $('.more-info');

    if (flag) {
        $el.each(function () {
            var $target = $($(this).data('target'));

            $target.addClass('collapse');
        });
    } else {
        $el.each(function () {
            var $target = $($(this).data('target'));

            $target.removeClass('collapse').attr('style','');
        });
    }
};
export const scrollStart = ($el) => {
    var $section = $el.closest('.section'),
        $next = $section.next(),
        offset = $('#header').outerHeight(true) + Number($section.css('margin-bottom').replace('px',''));

    scrollTo($next, offset);
};
export const scrollToTarget = ($anchor, offset) => {
    var target = $anchor.data('scrollto');

    scrollTo($(target), offset);
};
export const scrollTo = ($el, offset) => {
    var $header = $('#responsive-header').length ? $('#responsive-header') : $('#header'),
        $window = $(window);

    offset = ($window.width() < breakpoints.md) ? $header.outerHeight(true) + (offset || 0) : (offset || 0);

    if ($el.length) {
        $('html, body').animate({
            scrollTop: $el.offset().top - offset
        }, 500);
    }
};
export const createAlert = (data, type) => {
    var $alert = $('<div />'),
        alertClass = 'website-alerts__alert',
        $websiteAlerts = $('#website-alerts');

    if (data.statusText == 'abort') {
        return;
    }

    // remove other alerts
    $websiteAlerts.children().remove();

    if (!data.message) {
        data.message = 'There was an error with your request. Please try again.';
    }

    // create alert
    if (type) {
        $alert.addClass(alertClass + '--' + type);
    }
    $alert.addClass(alertClass);
    $alert.append(
        '<div class="container">' +
        '<button typeo="button" class="website-alerts__close" title="Close"><i class="icon icon-close"></i></button>' +
        '<div class="website-alerts__message">' + data.message + '</div>' +
        '</div>'
    );
    $websiteAlerts.prepend($alert);

    showAlert($alert);

    closeAlert($alert);

    return $alert;
};
export const createAlertOnLoad = () => {
    var $websiteAlerts = $('#website-alerts'),
        alertClass = 'website-alerts__alert',
        $alert = $websiteAlerts.children('.' + alertClass);

    if (!$alert.length) {
        return false;
    }

    // show alert
    showAlert($alert);

    // close alert
    closeAlert($alert);
};
export const showAlert = ($el) => {
    $el.fadeIn().delay(8000).fadeOut(function() {
        $(this).remove();
    });
};
export const closeAlert = ($el) => {
    var alertCloseClass = 'website-alerts__close',
        alertClass = 'website-alerts__alert';

    $el.on('click', '.' + alertCloseClass, function(event) {
        event.preventDefault();
        $(this).closest('.' + alertClass).stop(true).fadeOut(function() {
            $(this).remove();
        });
    });
};
export const hideBackdrop = () => {
    $('body').removeClass('menu-active sidebar-active cart-active');
};
export const binds = () => {
    // -------------------
    // BINDS
    // -------------------

    createAlertOnLoad();

    // ---------------- scroll start
    $('[data-scroll-start]').on('click.scroll', function() {
        scrollStart($(this));
    });

    // ---------------- scroll to
    $('body').on('click.window', '[data-scrollto]', function(event) {
        event.preventDefault();
        scrollToTarget($(this));
    });

    // ---------------- backdrop click
    $('#backdrop').on('click.window', function() {
        hideBackdrop();
    });

    // ---------------- window events
    $(window).on('resize.window', function() {
        clearTimeout(timeout.resize);
        timeout.resize = setTimeout(function(){
            resize();
        }, 100);
    });
    // $(window).on('hashchange.window', function () {
    //     hashChange();
    // });
    $(window).on('scroll.window', function () {
        clearTimeout(timeout.scroll);
        timeout.scroll = setTimeout(function(){
            scroll();
        }, 10);
    });
    $(window).triggerHandler('resize.window');
    // $(window).triggerHandler('hashchange.window');
    $(window).triggerHandler('scroll.window');
};
